import React, { FC, useLayoutEffect } from 'react';
import { Button, useWasOpenedByWindowOpen, X } from 'shared-components';

export const CloseWindowOnSuccessButton: FC<{}> = ({}) => {
  const isOpenedInWindow = useWasOpenedByWindowOpen();

  useLayoutEffect(() => {
    if (isOpenedInWindow && window.opener) {
      window.opener.postMessage(JSON.stringify({ type: 'success' }), '*');
    }
  }, [isOpenedInWindow]);

  return isOpenedInWindow ? (
    <Button
      variant="primary-white"
      onClick={() => {
        if (window.opener) {
          window.opener.postMessage(JSON.stringify({ type: 'close' }), '*');
        }
        window.close();
      }}
    >
      Close
    </Button>
  ) : null;
};
